import { render } from "./WhoWeAre.vue?vue&type=template&id=911716ae&scoped=true"
const script = {}

import "./WhoWeAre.vue?vue&type=style&index=0&id=911716ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911716ae"]])

export default __exports__